import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ChannelForm.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import channelService from '../../services/channelService';
import phoneService from "/src/features/administration/phone/services/phoneService";
import Form from '/src/components/form/Form';

import Dropdown from '../../../../../components/UI/DropDown/DropDown';
 
import botService from '/src/features/bot/services/botService'
import channelsType from '/src/data/dropdown/channelsType'
import Field from '/src/components/UI/Field/Field';

import Button from "/src/components/UI/Button/Button";
import Slider, { Slide, ScrollIntoSlide } from '/src/components/slider/sliderView';
import TextInput from "/src/components/UI/TextField/TextInput"
import { useForm } from 'react-hook-form';

import { setUpVoices } from "/src/utils/setUpVoices";

import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";

import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import "/src/assets/css/polices.css"
import "./ChannelForm.css"
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import InputRange from "/src/components/UI/InputRange/InputRange";
import generateKey from "/src/utils/generateKey";

import CheckBox from '/src/components/UI/CheckBox/CheckBox';

function ChannelForm() {
    const { register, handleSubmit, watch, formState: { errors }, formState, getValues, setValue } = useForm({
        mode: "onChange",
        defaultValues: {
            voices: " ",
            sound_effect: false,
            notification: false,
            ripple_effect: false,
        }
    });
    const { addChannel } = channelService;

    const { getBotsChannels, getVoices, getBotsShared } = botService;
    const { getPhones } = phoneService;
    const [listCheckedPhone, setListCheckedPhone] = useState([])

    const [bots, setBots] = useState("");
    const [voices, setVoices] = useState("")
    const [phones, setPhones] = useState([])
    const [file, setFile] = useState();
    const [key, setKey] = useState();
    const [loadAnim, setLoading] = useState(null);
    const [runBotState, setRunBotState] = useState(0);
    const [partSlide, setPartSlide] = useState("choose-bot")
    const navigate = useNavigate();

    const handleInputRangeChange = (name, value) => {
        setRunBotState(parseInt(value));
        setValue('run_bot_delay',parseInt(value));
    };

    const getAllBots = async () => {
        let responses = await Promise.all([getBotsShared(), getBotsChannels()])
        const [getBotsSharedResponse, getBotsChannelsResponse] =  responses;
        if(getBotsSharedResponse[1] != null) {
            console.log(getBotsSharedResponse[1]);
            return
        }

        if(getBotsChannelsResponse[1] != null) {
            console.log(getBotsChannelsResponse[1]);
            return
        }

        const response = [...getBotsSharedResponse[0], ...getBotsChannelsResponse[0]];
        response.sort((a, b) =>  (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? 1 : 0))
        setBots(setUpBots(response));
    }
    const setUpBots = (bots) => {
        let arrayBot = [];
        bots.forEach(bot =>
            arrayBot.push({
                value: bot.id,
                text: <><img srcSet={bot.company.logo} title={bot.company.name} alt="" width="25px"></img><div className="channel_content_dropdown"> {bot.name} </div></>
            })
        )
        return arrayBot;
    }

    const getAllVoicesById = async () => {
        let [response, error] = await getVoices(parseInt(getValues("bot")))
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = setUpVoices(response)
        setVoices(res);
        return response;
    }

    const getAllPhonesById = async () => {
        let [response, error] = await getPhones()
        if (error !== null) {
            console.log(error);
            return;
        }
        response = response.filter(phone => phone.channel == null && phone.is_mutu == false)
        setPhones(response);
        return response;
    }

    const checkPhone = (_phone) => {
        let result = listCheckedPhone;
        if (result.filter((phone) => { return phone.id == _phone.id; }).length == 0) { // if dataset is not checked
            result.push(_phone);
            setListCheckedPhone(result)
            document.getElementById(_phone.id + "button").style.color = "var(--green)"
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-check-circle"

        }
        else { // if dataset is already checked
            let index = listCheckedPhone.findIndex(phone => { return phone.id === _phone.id });
            result.splice(index, 1)
            setListCheckedPhone(result)

            document.getElementById(_phone.id + "button").style.color = "var(--main)"
            document.getElementById(_phone.id + "button").children[0].classList = "fas fa-plus-circle"
        }
    }

    const getPhoneNumberSpaced = (phone) => {
        let str = ""
        for (let i = 0; i < phone.length; i++) {
            str += phone[i]
            if ((i - 1) % 2 == 0) {
                str += " "
            }
        }
        return str
    }

  

    const onSubmit = async () => {

        var dataToSend = getValues();
        const formData = new FormData();

        if (listCheckedPhone.length > 0){
            let listPhoneIds = listCheckedPhone.map(phone => phone.id);
            formData.append("numbers", JSON.stringify(listPhoneIds));
        }

        formData.append("name", dataToSend.name);
        formData.append('type_id', dataToSend.channel == "telephony" ? 3 : 1) // web = 1 , tel = 0
        formData.append('bot_id', parseInt(dataToSend.bot))
        formData.append('color', dataToSend.color_bot)
        formData.append('avatar', file)
        formData.append("delay_run_chatbox", dataToSend.run_bot_delay)
        formData.append("sound_effect", dataToSend.sound_effect)
        formData.append("notification", dataToSend.notification)
        formData.append("ripple_effect", dataToSend.ripple_effect)
        

        let [response, error] = await addChannel(formData)
        if (error !== null) {
            console.log(error);
            return;
        }
        return navigate(urlWithRoutingCompany('/plugin/channels/list'));
    }
    useEffect(() => {
        getAllBots();
    }, [])

    const ChannelTelephonySlide = () => <>
        <div>
            <Field listClassName="flex no-margin_left" label={
                <span className={"normal_font-weight"}>Make your <span className={"bold_font-weight"}> Bot </span> available on a phone number</span>}>
            </Field>
        </div>

        <br />
        <Field listClassName="flex no-margin_left" label="Select some phone numbers">
        </Field>
        <div className="container_phone_list_channel">
            {phones.length > 0 ?
                <div>
                    <div className="phone_list_channel">
                        {phones.map((phone, i) => {
                            return (
                                <div className="project-block" data-checked="false" data-id={phone.id} key={generateKey()}>
                                    <div style={{ alignItems: "center", display: "flex" }}>
                                        <i style={{ marginRight: '15px', fontSize: "20px" }} className={'flag-icon flag-icon-' + phone.country.alpha_code_2.toLowerCase()}></i>
                                        {getPhoneNumberSpaced(phone.numbers)}
                                    </div>
                                    <div>
                                        <IconButton id={phone.id + "button"} className="main-iconButton add-hover modalButtons-input" icon="fas fa-plus-circle" onClick={(e) => checkPhone(phone)} />

                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                :
                null
            }
        </div>
    </>;

    const ChannelWebSlide = () => <>
        <div>
            <Field listClassName="flex no-margin_left" label={
                <span className={"normal_font-weight"}>Customize your <span className={"bold_font-weight"}>Chatbox</span>,
                    give her a <span className={"bold_font-weight"}>face</span>,
                    and start the <span className={"bold_font-weight"}>robot</span> of <span className={"bold_font-weight"}>tomorrow</span>
                </span>
            }>
            </Field>
        </div>
        <br />
        <br />

        <div>
            <Field listClassName="flex no-margin_left" label={
                <span className={"normal_font-weight"}>Having a good <span className={"bold_font-weight"}>picture</span>,
                    and good<span className={"bold_font-weight"}>colors</span>,
                    is very <span className={"bold_font-weight"}>useful</span> for a <span className={"bold_font-weight"}>bot</span>
                    on the <span className={"bold_font-weight"}> web </span>
                </span>
            }>
            </Field>
            <br />
            <br />
            <div className="main_container_color_part">
                <div className="avatar-area">
                    <Field label="Avatar"></Field>
                    <div>
                        <ChooseFile _setFile={setFile} accept=".png" loadAnim={loadAnim}></ChooseFile>
                    </div>
                </div>
                <div className="color_area">
                    <Field label="Chatbox color"></Field>
                    <div className="input_color-container">
                        <input  {...register('color_bot')} defaultValue="#0e7aed" type="color" className="input_color"></input>
                    </div>
                </div>
            </div>
            <div className="run_bot_block">
                <Field label="Automatic bot opening delay" />
                <div className="input-range-container">
                    <InputRange  {...register('run_bot_delay')}  _setValue={handleInputRangeChange}  min="0" max="10" />
                    <span className="range-value" style={{left:`${(runBotState / 10) * 100}%`}}>
                        {runBotState}
                    </span>
                </div>
            </div>
        </div>
    </>;

    const ChannelRcsSlide = () => <>
    <div>
        <Field listClassName="flex no-margin_left" label={
            <span className={"normal_font-weight"}>Make your bot available on the <span className={"bold_font-weight"}>rcs channel of google</span>,
            </span>
        }>
        </Field>
    </div>
    <br />
    <br />

    <div>
        <Field listClassName="flex no-margin_left" label={
           <span className={"normal_font-weight"}>Register your agent key just beside to make it enable for <span className={"bold_font-weight"}>your customers</span></span>
        }>
        </Field>
        <br />
        <br />
        <div className="main_container_rcs">
            <div style={{ marginLeft : 15 }}>
                <Field label="Bot key"></Field>
                <div className="key_container">
                    <input  {...register('key_file')} type="file" accept=".json"></input>
                </div>
            </div>
        </div>
    </div>
    </>;

    const ChannelWebParameterSlide = () => <>
    <div>
        <Field listClassName="flex no-margin_left" label={
            <span className={"normal_font-weight"}>Customize your <span className={"bold_font-weight"}>Chatbox</span>,
                enable <span className={"bold_font-weight"}>sound effect, notification</span>,
                and <span className={"bold_font-weight"}>ripple effect</span>
            </span>
        }>
        </Field>
    </div>
    <br />
    <br />

    <div>
        <Field label={<span>Enable Sound Effect</span>} listLabelClassName="titles-input" listClassName={"flex no-margin_left"}>
            <CheckBox {...register('sound_effect')} name="sound_effect" onChange={e => setValue('sound_effect', e.target.checked ? true : false)}/>
        </Field>
        <Field label={<span>Enable Notification</span>} listLabelClassName="titles-input" listClassName={"flex no-margin_left"}>
            <CheckBox {...register('notification')} name="notification" onChange={e => setValue('notification', e.target.checked ? true : false)}/>
        </Field>
        <Field label={<span>Enable Ripple Effect</span>} listLabelClassName="titles-input" listClassName={"flex no-margin_left"}>
            <CheckBox {...register('ripple_effect')} name="ripple_effect" onChange={e => setValue('ripple_effect', e.target.checked ? true : false)}/>
        </Field>
    </div>
    </>;

    return (
        <Form className="space-right-channel">
            <Form.Title>Broadcast your bot</Form.Title>
            <Form.Body className="form_channel_center">
                <Slider className={"slider-channel_form"}>

                    <Slide name="choose-bot">
                        <br />
                        <div>
                            <Field listClassName="flex no-margin_left" label={
                                <span className={"normal_font-weight"}>Choose a <span className={"bold_font-weight"}>Bot </span>,
                                    Provide a <span className={"bold_font-weight"}>Scenario </span>,
                                    pic a <span className={"bold_font-weight"}>Bot </span> and share your it with the <span className={"bold_font-weight"}>World </span>.
                                </span>
                            }>
                            </Field>
                        </div>
                        <br />
                        <div>
                            <Field label={<span style={{ marginLeft: "15px" }}> Name <span className="obligatory_field">*</span> </span>} listLabelClassName="titles-input">
                                <TextInput {...register('name', { required: true, minLength: 3 })} style={{ width: "85%", marginBottom: "0", marginLeft: "15px", borderColor: errors.name ? "red" : "" }} />
                                <span className='error' style={{ marginRight: "40px" }}>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters") : ""}</span>
                            </Field>
                        </div>
                        <div className="div_container_dropdown_channel">
                            <Field label="Channel" listLabelClassName="bold_font-weight flex space_dowpdownTop"></Field>
                            <div id="channelType" className="container_dropdown_channel channels_type" >
                                <Dropdown {...register('channel')} setValue={setValue} choices={channelsType} defaultChoice="web" width="120px"></Dropdown>
                            </div>
                        </div>
                        <br />
                        {
                            Array.isArray(bots) ?

                                <div className="div_container_dropdown_channel">
                                    <Field label="Select a Bot" listLabelClassName="bold_font-weight flex space_dowpdownTop"></Field>
                                    <div className="container_dropdown_channel" >
                                        <Dropdown {...register('bot')} setValue={setValue} choices={bots} defaultChoice="web" width="220px"></Dropdown>
                                    </div>
                                </div>
                                : null
                        }
                        <br />
                        <br />
                        <div style={{ marginTop: "25px", display: "flex" }}>
                            <Field label="New channels are coming soon ! keep listening." listLabelClassName="flex"></Field>
                        </div>
                    </Slide>

                    <Slide name="customize-bot">
                        {
                            watch("channel") == "telephony" ? <ChannelTelephonySlide></ChannelTelephonySlide> : null
                        }
                        {
                            watch("channel") == "web" ? <ChannelWebSlide></ChannelWebSlide> : null
                        }
                        {
                            watch("channel") == "rcs" ? <ChannelRcsSlide></ChannelRcsSlide> : null
                        }
                    </Slide>

                     <Slide name="customize-bot-parameter">
                        {
                            watch("channel") == "web" ? <ChannelWebParameterSlide></ChannelWebParameterSlide> : null
                        }
                    </Slide>

                </Slider>
            </Form.Body>

            <Form.Buttons className="space_buttons">
                <Button type="button" className="cancel" label="Return" onClick={() => {if (partSlide === "customize-bot-parameter") {
                            ScrollIntoSlide("customize-bot");
                            setPartSlide("customize-bot");
                        } else {
                            ScrollIntoSlide("choose-bot");
                            setPartSlide("choose-bot");
                        }
                    }}
                    style={{ opacity: partSlide === "choose-bot" ? 0 : 1, cursor: partSlide === "choose-bot" ? "default" : "pointer" }}
                />
                {partSlide === "choose-bot" ? (
                    <Button type="button" className="validate" label="Next Step" onClick={() => {ScrollIntoSlide("customize-bot"); setPartSlide("customize-bot"); watch("channel") === "telephony" ? (getAllVoicesById(), getAllPhonesById()) : "";}} />
                ) : partSlide === "customize-bot" && watch("channel") === "web" ? (
                    <Button type="button" className="validate" label="Next Step" onClick={() => { ScrollIntoSlide("customize-bot-parameter"); setPartSlide("customize-bot-parameter");}} />
                ) : (
                    <Button id="submit_channel_form" type="button" className="validate" label="Validate" onClick={onSubmit} disabled={!(watch("name")?.length > 3)} />
                )}
            </Form.Buttons>

        </Form >

    );
}

export default ChannelForm;